<template>
    <v-select @search="fetchOrgs"
              label="name"
              :options="orgs"
              @option:selected="select"
              :placeholder="placeholder">
        <template #option="org">
            <div class="name">{{ org.name }}</div>
            <div class="address" v-if="org.meta.address">{{ org.meta.address }}</div>
        </template>
    </v-select>
</template>

<script>
import API from "@/API";
import vSelect from "vue-select-3/src/index";

export default {
    name: "OrganizationSelector",
    components: {vSelect},
    emits: ['change', 'ready', 'update:modelValue'],

    props: {
        modelValue: {
            type: Number,
            default: () => null,
        },
        placeholder: {
            type: String,
            default: 'Organization',
        },
    },

    data(){
        return {
            orgs: [],
            selected: null,
        }
    },

    watch: {
        selected(org){
            this.$emit('update:modelValue', org?.id ?? null);
            this.$emit('change', org);
        }
    },

    methods: {
        async fetchOrgs(search, loading){
            this.orgs = (await API.organizations.bulk({q: search})).data;
        },
        select(option){
            this.selected = option;
        }
    },

    async beforeMount() {
        this.selected = this.modelValue;
        if( this.modelValue ){
            this.orgs = (await API.organizations.bulk({ids: this.modelValue})).data;
            this.selected = this.orgs[0].id ?? this.modelValue;
        }

        this.$emit('ready');

    }
}
</script>

<style lang="scss" scoped>
.address{
    font-weight: $font-weight-normal;
    font-size: 0.9em;
}
</style>
